<!-- Product Area Selection -->
<div class="flex h-full flex-col lg:container" [class.country]="isCountryArea">
    <!-- Header Section -->
    <div class="z-10 bg-white p-4 pb-5 shadow-md md:shadow-none">
        <!-- Title and Zone Map Link -->
        <div class="mb-4 flex items-center justify-between">
            <div class="bg-white text-base">{{ 'SELECT_AREA_TO_TRAVEL_WITHIN' | translate }}</div>
            <button
                class="sr-app-light:hidden var-app-light:text-primary cursor-pointer text-base normal-case text-secondary dark:text-contrast-yellow"
                (click)="openZoneMap()"
                type="button">
                {{ 'VIEW_ZONE_MAP' | translate }}
            </button>
        </div>

        <!-- Area Type Selector (1 Area / 2 Areas / County) -->
        <ion-segment
            class="var-app-light-dark:border-2 var-app-light-dark:border-solid var-app-light-dark:border-black var-app-light-dark:border-opacity-10 var-app-light-dark:h-11 orb-app-light-dark:h-11"
            [(ngModel)]="productAreaType"
            color="dark"
            mode="ios">
            <!-- 1 Area -->
            <ion-segment-button
                class="orb-app-light-dark:text-base orb-app-light:text-grey-zambezy orb-app-light-dark:font-bold vl-app-light-dark:font-medium var-app-light-dark:text-base var-app-light-dark:font-semibold var-app-light:text-grey-zambezy text-sm uppercase"
                [value]="AreasCountTypes.ONE_AREA"
                [ngClass]="{
                    'text-black dark:text-contrast-black': productAreaType === AreasCountTypes.ONE_AREA,
                    'normal-case': env.REMOVE_UPPERCASE
                }"
                (click)="areaSelected(null)">
                <ion-label [ngClass]="{ 'dark:text-contrast-black': productAreaType === AreasCountTypes.ONE_AREA }">{{
                    'AREA_OPTION_1_AREA' | translate
                }}</ion-label>
            </ion-segment-button>

            <!-- 2 Areas -->
            <ion-segment-button
                class="orb-app-light-dark:text-base orb-app-light:text-grey-zambezy orb-app-light-dark:font-bold vl-app-light-dark:font-medium var-app-light-dark:text-base var-app-light-dark:font-semibold var-app-light:text-grey-zambezy text-sm uppercase"
                *ngIf="twoAreas"
                [value]="AreasCountTypes.TWO_AREAS"
                [ngClass]="{
                    'text-black dark:text-contrast-black': productAreaType === AreasCountTypes.TWO_AREAS,
                    'normal-case': env.REMOVE_UPPERCASE
                }"
                (click)="areaSelected(null)">
                <ion-label [ngClass]="{ 'dark:text-contrast-black': productAreaType === AreasCountTypes.TWO_AREAS }">{{
                    'AREA_OPTION_2_AREAS' | translate
                }}</ion-label>
            </ion-segment-button>

            <!-- County -->
            <ion-segment-button
                class="orb-app-light-dark:text-base orb-app-light:text-grey-zambezy orb-app-light-dark:font-bold vl-app-light-dark:font-medium var-app-light-dark:text-base var-app-light-dark:font-semibold var-app-light:text-grey-zambezy text-sm uppercase"
                *ngIf="areaOptions[AreasCountTypes.COUNTY]?.length || areaOptions[AreasCountTypes.COUNTY]?.id"
                [value]="AreasCountTypes.COUNTY"
                [ngClass]="{
                    'text-black dark:text-contrast-black': productAreaType === AreasCountTypes.COUNTY,
                    'normal-case': env.REMOVE_UPPERCASE
                }"
                (click)="
                    areaSelected(env.PURCHASE_FLOW?.SHOW_COUNTY_AREA_GRID ? null : areaOptions[AreasCountTypes.COUNTY])
                ">
                <ion-label [ngClass]="{ 'dark:text-contrast-black': productAreaType === AreasCountTypes.COUNTY }">{{
                    'AREA_OPTION_COUNTY' | translate
                }}</ion-label>
            </ion-segment-button>
        </ion-segment>

        <!-- County Information Alert -->
        <div class="county mt-6 w-full" *ngIf="isCountryArea">
            <div class="flex rounded-lg bg-[#F0F0F0] px-6 py-4 dark:bg-contrast-black">
                <ion-icon
                    class="success-icon mr-4 mt-4 h-8 w-8 min-w-[1.5rem] dark:filter-yellow"
                    src="{{ assetsPath$ | async }}/img/purchase-flow-v2/result/info-icon.svg"></ion-icon>
                <span class="vl-app-light:text-[#085667] text-base font-normal">
                    {{ 'PURCHASE_COUNTRY_INFORMATION' | translate }}
                </span>
            </div>
        </div>
    </div>

    <!-- Main Content Area -->
    <div
        class="areas flex flex-col overflow-y-auto"
        [ngClass]="{
            'justify-between': productAreaType !== AreasCountTypes.COUNTY,
            'justify-center': productAreaType === AreasCountTypes.COUNTY
        }">
        <div></div>

        <!-- Zone Map Image -->
        <div class="flex-align-center flex justify-center py-2" *ngIf="!env.PURCHASE_FLOW?.HIDE_MAP">
            <gl-area-image [selectedArea]="selectedArea" (imageClick)="openZoneMap()"></gl-area-image>
        </div>

        <!-- Area Selection Grid -->
        <div
            class="grid gap-4 bg-white p-4 shadow-md"
            *ngIf="shouldShowAreaGrid"
            [ngClass]="{ 'grid-cols-3': !bigButtons, 'grid-cols-1 md:grid-cols-2': bigButtons }">
            <!-- Area Options -->
            <div #areas *ngFor="let option of currentAreaOptions" [id]="option.id">
                <button
                    class="chip-style-btn bg-grey-soft_silver sr-app-light-dark:h-14 sr-app-light:bg-white sr-app-light-dark:rounded-lg sr-app-light-dark:text-base sr-app-light-dark:font-light sr-app-light-dark:shadow vl-app-light-dark:h-12 vl-app-light-dark:border-grey-cloud vl-app-light-dark:text-base vl-app-light-dark:font-normal var-app-light-dark:h-12 var-app-light-dark:w-27 var-app-light-dark:text-base var-app-light-dark:text-center orb-app-light-dark:h-12 orb-app-light-dark:w-27 orb-app-light-dark:text-base orb-app-light-dark:text-center m-0 flex h-8 justify-center rounded-full border border-solid shadow-none dark:!border-contrast-yellow dark:bg-contrast-yellow dark:!text-contrast-black"
                    [ngClass]="{
                        'active vl-app-light-dark:font-bold border-primary font-bold dark:border-contrast-yellow dark:!text-contrast-yellow':
                            selectedArea?.id === option.id
                    }"
                    [attr.aria-pressed]="selectedArea?.id === option.id"
                    [outline]="selectedArea?.id === option.id"
                    (click)="areaSelected(option, $event)"
                    (keydown.enter)="areaSelected(option, $event)"
                    tabindex="0"
                    type="button">
                    {{ option.name | translateObjectField: null : currentLanguage }}
                </button>
            </div>
        </div>

        <ng-content></ng-content>
    </div>

    <!-- Free Travel Message Alert -->
    <div
        class="flex flex-col bg-white p-4"
        *ngIf="
            env.PURCHASE_FLOW?.FREE_TRAVEL_MESSAGE_IN_DESCRIPTION &&
            (selectedArea?.description | translateObjectField: null : currentLanguage)
        ">
        <ridango-ui-alert type="info">
            <div>
                {{ selectedArea.description | translateObjectField: null : currentLanguage }}
            </div>
        </ridango-ui-alert>
    </div>
</div>
